module.exports = __webpack_public_path__ + "img/edomelogo.7f9b1aa6.svg";